import styled from "@emotion/styled";
import { OLD_BLUE, PRIMARY_FONT } from "src/constants/colors";

export const StyledInput = styled.input`
  background-color: transparent;
  border: 0;
  caret-color: ${OLD_BLUE};
  color: ${PRIMARY_FONT};
  font-size: 16px;
  font-weight: 400;
  outline: none;
  width: 355px;
  height: 25px;
`;

export const ButtonLabelText = styled.span`
  display: inline-flex;

  & strong {
    font-weight: 700;
    text-transform: capitalize;
  }
`;
